<template>
	<button class="view-ui-button-back button-primary" v-on:click="Handle_OnClickBack">Back</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonBack extends ViewBase {
		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickBack(e: PointerEvent): Promise<void> {
			e.preventDefault();

			this.$router.go(-1);
		}
	}
</script>
